import { DesktopWindows, PhoneIphone } from '@mui/icons-material';
import { Box, Tab, Tabs } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { GenericDialog } from 'src/shared/components/organisms/genericDialog';
import { GroupMessageEmailTemplateView } from './groupMessageEmailTemplateView';

type EmailTemplatePreviewModalProps = {
  open: boolean;
  onClose: () => void;
  templateName: string;
  body: string;
};

type ViewMode = 'desktop' | 'mobile';

const MOBILE_VIEWPORT_WIDTH = 390;

export const EmailTemplatePreviewModal = (props: EmailTemplatePreviewModalProps) => {
  const { open, onClose, templateName, body } = props;
  const { t } = useTranslation(['common', 'groupMessage']);
  const [viewMode, setViewMode] = useState<ViewMode>('desktop');

  return (
    <GenericDialog
      open={open}
      onClose={onClose}
      onSave={onClose}
      showDialogActions={false}
      maxWidth='lg'
      padding={0}
      dialogTitle={t(templateName)}
      dialogSubTitle={t('groupMessage:emailTemplates.previewSubtitle') as string}
      dialogContent={
        <Box sx={{ display: 'flex', flexDirection: 'column', height: '75vh' }}>
          <Tabs
            value={viewMode}
            onChange={(_, value: ViewMode) => setViewMode(value)}
            variant='fullWidth'
            sx={{ borderBottom: 1, borderColor: 'divider' }}
          >
            <Tab
              value='desktop'
              icon={<DesktopWindows fontSize='small' />}
              iconPosition='start'
              label={t('groupMessage:emailTemplates.previewDesktop')}
            />
            <Tab value='mobile' icon={<PhoneIphone fontSize='small' />} iconPosition='start' label={t('groupMessage:emailTemplates.previewMobile')} />
          </Tabs>

          <Box
            sx={{
              flex: 1,
              minHeight: 0,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'stretch',
              bgcolor: (theme) => theme.palette.grey[100],
              p: viewMode === 'mobile' ? 3 : 0,
              overflow: 'auto',
            }}
          >
            {viewMode === 'desktop' ? (
              <Box sx={{ width: '100%', height: '100%' }}>
                <GroupMessageEmailTemplateView body={body} height='100%' />
              </Box>
            ) : (
              <Box
                sx={{
                  width: MOBILE_VIEWPORT_WIDTH,
                  maxWidth: '100%',
                  height: '100%',
                  borderRadius: 4,
                  border: '8px solid',
                  borderColor: 'grey.800',
                  bgcolor: 'background.paper',
                  overflow: 'hidden',
                  boxShadow: 3,
                }}
              >
                <GroupMessageEmailTemplateView body={body} height='100%' />
              </Box>
            )}
          </Box>
        </Box>
      }
    />
  );
};
